import React from "react";
import Typography from "@material-ui/core/Typography";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import BSL_Button from "../../components/BSL_Button";

const useStyles = makeStyles({
    grow: {
        flexGrow: 1,
    },
    closeButton: {
        float: "right",
        marginTop: "0px",
        marginRight: "-20px",
        color: "white",
    },
});

export default (props) => {
    const classes = useStyles();

    let background_colour = "linear-gradient(0.25turn, #192E61, #243F84)";
    if (window.test) background_colour = "linear-gradient(0.25turn, #c78219, #f49507)";
    if (window.debug) background_colour = "linear-gradient(0.25turn, #565656, #AAAAAA)";

    let button_style = {
        background: "#eaeaea",
        color: "#2d2d2d",
    };
    if (window.test || window.debug) button_style = {};

    return (
        <AppBar
            id={props.id}
            position="static"
            style={props.style ? props.style : { background: background_colour, position: "sticky", top: "0px" }}
        >
            <Toolbar variant="dense">
                <Typography variant="h6" color="inherit" className={classes.grow}>
                    {props.title}
                </Typography>
                {props.DatePickerComponent && (
                    <div style={{ backgroundColor: "white", margin: "10px", borderRadius: "10px" }}>
                        {props.DatePickerComponent}
                    </div>
                )}
                {props.button2Text && (
                    <BSL_Button
                        disabled={props.disabled}
                        style={{ color: "white" }}
                        secondary
                        onClick={() => props.button2Click()}
                    >
                        {props.button2Text}
                    </BSL_Button>
                )}
                {props.button1Text && (
                    <BSL_Button
                        disabled={props.disabled}
                        id="back_button"
                        onClick={() => props.button1Click()}
                        style={button_style}
                    >
                        {props.button1Text}
                    </BSL_Button>
                )}
                {props.text1 && props.text1}
                <IconButton id="Quote-close-button" className={classes.closeButton} onClick={() => props.onClick()}>
                    <CloseIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    );
};
